import { c } from 'react-compiler-runtime';
import classes from './Spinner.module.css.js';
import { clsx } from 'clsx';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useId } from '../hooks/useId.js';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';

const sizeMap = {
  small: '16px',
  medium: '32px',
  large: '64px'
};
function Spinner(t0) {
  var _ariaLabel;
  const $ = c(25);
  let ariaLabel;
  let className;
  let props;
  let style;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      size: t1,
      srText: t2,
      "aria-label": ariaLabel,
      className,
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = ariaLabel;
    $[2] = className;
    $[3] = props;
    $[4] = style;
    $[5] = t1;
    $[6] = t2;
  } else {
    ariaLabel = $[1];
    className = $[2];
    props = $[3];
    style = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const sizeKey = t1 === undefined ? "medium" : t1;
  const srText = t2 === undefined ? "Loading" : t2;
  const size = sizeMap[sizeKey];
  const hasHiddenLabel = srText !== null && ariaLabel === undefined;
  const labelId = useId();
  const t3 = (_ariaLabel = ariaLabel) !== null && _ariaLabel !== void 0 ? _ariaLabel : undefined;
  const t4 = hasHiddenLabel ? labelId : undefined;
  let t5;
  if ($[7] !== className) {
    t5 = clsx(className, classes.SpinnerAnimation);
    $[7] = className;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = /*#__PURE__*/jsx("circle", {
      cx: "8",
      cy: "8",
      r: "7",
      stroke: "currentColor",
      strokeOpacity: "0.25",
      strokeWidth: "2",
      vectorEffect: "non-scaling-stroke"
    });
    t7 = /*#__PURE__*/jsx("path", {
      d: "M15 8a7.002 7.002 0 00-7-7",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      vectorEffect: "non-scaling-stroke"
    });
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] !== props || $[12] !== size || $[13] !== style || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t8 = /*#__PURE__*/jsxs("svg", {
      height: size,
      width: size,
      viewBox: "0 0 16 16",
      fill: "none",
      "aria-hidden": true,
      "aria-label": t3,
      "aria-labelledby": t4,
      className: t5,
      style: style,
      ...props,
      children: [t6, t7]
    });
    $[11] = props;
    $[12] = size;
    $[13] = style;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== hasHiddenLabel || $[19] !== labelId || $[20] !== srText) {
    t9 = hasHiddenLabel ? /*#__PURE__*/jsx(VisuallyHidden, {
      id: labelId,
      children: srText
    }) : null;
    $[18] = hasHiddenLabel;
    $[19] = labelId;
    $[20] = srText;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t8 || $[23] !== t9) {
    t10 = /*#__PURE__*/jsxs("span", {
      className: classes.Box,
      children: [t8, t9]
    });
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}
Spinner.displayName = 'Spinner';

export { Spinner as default };
